// @flow
import React, { Component } from 'react';

import api from '../../../../../../services/api';

import style from './style';
import Search from './components/Search/Search';
import UserRow from './components/UserRow/UserRow';

class UserSelect extends Component<{
  selected: Array<string>,
  onChange: Function,
}, {
  users: Array<Object>,
  selected: Array<string>,
}> {
  constructor(props: Object) {
    super(props);
    this.state = {
      users: [],
      selected: this.props.selected,
    };
  }

  componentWillMount() {
    api.users.getList((res) => { this.onUsersLoaded(res); });
  }

  onUsersLoaded(list: Array<Object>) {
    list.sort(this.compareName);
    this.setState({ users: list });
  }

  onChange(id: string) {
    const newSelected = this.state.selected;
    if (newSelected.indexOf(id) === -1) {
      newSelected.push(id);
    } else {
      newSelected.splice(newSelected.indexOf(id), 1);
    }

    this.setState({ selected: newSelected });
    this.props.onChange(newSelected);
  }

  search(value: string) {
    api.users.search(value, (res) => { this.onUsersLoaded(res); });
  }

  generateList(): Array<Object> {
    const selected = this.state.selected;

    return this.state.users.map((user: Object) => (<UserRow
      key={user.id}
      name={`${user.profile.name.givenName} ${user.profile.name.familyName}`}
      picture={user.profile.image.url}
      checked={(selected.indexOf(user.id) > -1)}
      onToggle={() => this.onChange(user.id)}
    />));
  }

  compareName(a: Object, b: Object): number {
    if (a.profile.name.givenName < b.profile.name.givenName) {
      return -1;
    }
    if (a.profile.name.givenName > b.profile.name.givenName) {
      return 1;
    }
    return 0;
  }

  render(): React.Node {
    return (<div style={style.window}>
      <Search onChange={(v: string) => this.search(v)} />
      <div style={style.list}>
        {this.generateList()}
      </div>
    </div>);
  }
}

export default UserSelect;



// WEBPACK FOOTER //
// ./src/scenes/Admins/components/AdminSettings/components/UserSelect/UserSelect.js